import type { ResolverConflitoFornecedorDialogProps } from "./types-resolver-conflito-fornecedor";
import { useResolverConflitoFornecedorDialog } from "./use-resolver-conflito-fornecedor";
import { ResolverConflitoFornecedorDialogView } from "./view-resolver-conflito-fornecedor";

/** Modal "Resolver Conflito de Alocação" do Fornecedor (HU 2041). */
export function ResolverConflitoFornecedorDialog(props: ResolverConflitoFornecedorDialogProps) {
  const vm = useResolverConflitoFornecedorDialog(props);

  return <ResolverConflitoFornecedorDialogView {...vm} />;
}

export {
  IGNORADO_SUCCESS_MESSAGE,
  INDICADORES_ATUALIZADOS_MESSAGE,
  REMANEJADO_SUCCESS_MESSAGE,
} from "./resolver-conflito-fornecedor.constants";
export type * from "./types-resolver-conflito-fornecedor";
